'use strict';

var _ = require('underscore'),
  $ = require('jquery'),
  CarouselBaseView = require('./CarouselBaseView'),
  globalisation = require('../../utilities/globalisation'),
  utilities = require('../../js/utilities'),
  CounterCarouselView;

CounterCarouselView = CarouselBaseView.extend({
  options: {
    slideClass: '.CounterCarousel-slide',
    pagination: false,
    arrows: false,
    speed: 600,
    delay: 3000,
    mobileFirst: true,
    slickMaxBreakpoint: 1023  // it stops being a slideshow at 1023px
  },

  initialize: function(options) {

    if (utilities._isMobileOrTabletDevice()) {
      options.autoplay = false;
      if (CounterCarouselView.__super__.options) {
        CounterCarouselView.__super__.options.autoplay = false;
      }
      if (this.options) {
        this.options.autoplay = false;
      }
    }

    this.options = _.defaults(this.options, CounterCarouselView.__super__.options);
    CounterCarouselView.__super__.initialize.call(this, options);

    this.initialiseCounterAnimation();
  },

  initialiseCounterAnimation: function() {
    return this.$('.CounterCarousel-figure-number').addClass('isActive').countTo({
      from: 0,
      speed: 1500,
      refreshInterval: 50,

      formatter: function(number) {
        number = Math.floor(number);
        return globalisation.formatNumber(number);
      },

      // Because of rounding errors, make sure that the final value is correct
      onComplete: function() {
        var $numberField = $(this),
          correctValue = $numberField.data('to');

        $numberField.text(globalisation.formatNumber(correctValue));
      }
    });
  }

}, {
  create: function($parent) {
    $parent.find('.CounterCarousel').each(function(n, el) {
      new CounterCarouselView({
        el: el
      });
    });
  }
});

module.exports = CounterCarouselView;



// WEBPACK FOOTER //
// ./assets/components/Carousel/CounterCarouselView.js